import { render, staticRenderFns } from "./ParamRelacionamentoForm.vue?vue&type=template&id=91b59c68"
import script from "./ParamRelacionamentoForm.vue?vue&type=script&lang=js"
export * from "./ParamRelacionamentoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports